/**
 * @description 屏幕检测工具
 * 不是横屏提示横屏，跳转页面可能不合适，可能会直接中断学习过程【现在的方案】
 * 不跳转页面的话，需要处理的逻辑太多
 */

!(function () {
  window.addEventListener('load', function () {
    checkScreen()
  })

  window.addEventListener('resize', function () {
    checkScreen()
  })

  function checkScreen () {
    if (
      window.location.pathname === '/horizontaltip' &&
      window.innerWidth > window.innerHeight
    ) {
      let curUrl=new URL(window.location.href)
      let form_uri=curUrl.searchParams.get('form_uri')
      
      window.location.href =form_uri?decodeURIComponent(form_uri): '/'
      return
    }
    if (
      window.innerWidth < window.innerHeight &&
      window.location.pathname !== '/horizontaltip'
    ) {
      console.log(
        `当前是竖屏:innerWidth$-${window.innerWidth},innerHeight-${window.innerHeight}`
      )
      window.location.href = `/horizontaltip?form_uri=${encodeURIComponent(window.location.href)}`
    }
  }
})()
